import { cloneElement, ReactElement } from 'react';

import { Box, Popover, PopoverContent, PopoverProps, PopoverTrigger, Portal, StyleProps } from '@bonusly/design-system';

import { ErrorBoundary } from '../../../error/error-boundary';
import { UserPopoverContent } from '../components/user-popover-content';

export interface UserPopoverProps extends StyleProps {
	children: ReactElement;
	isDisabled?: boolean;
	openDelay?: number;
	placement?: PopoverProps['placement'];
	userId: string;
}

export const UserPopover = ({ children, isDisabled, openDelay, placement, userId, ...rest }: UserPopoverProps) => {
	return (
		<ErrorBoundary>
			<Popover isLazy isOpen={isDisabled ? false : undefined} openDelay={openDelay} placement={placement} trigger="hover">
				<PopoverTrigger>{cloneElement(children, rest)}</PopoverTrigger>

				<Portal>
					<Box
						sx={{
							'& .chakra-popover__popper': {
								zIndex: 'popover',
							},
						}}
					>
						<PopoverContent borderColor="bg.subtle" boxShadow="xl">
							<UserPopoverContent userId={userId} />
						</PopoverContent>
					</Box>
				</Portal>
			</Popover>
		</ErrorBoundary>
	);
};
